/** Routes du module — propriétaire : Agent A4 — Favoris, modèles récurrents, demandes de devis (portail). */
import type { RouteObject } from 'react-router';
import { FileSignature, Heart, Repeat } from 'lucide-react';
import type { EntreeNav } from '../../../app/navigation';
import { RequirePermission } from '../../../shared/auth/session';
import { DetailDevis, ListeMesDevis, NouveauDevis } from './Devis';
import { MesFavoris, MesModeles } from './Favoris';

export const routesProFidelite: RouteObject[] = [
  { path: 'devis', element: <RequirePermission permission="devis.lire.propres"><ListeMesDevis /></RequirePermission> },
  { path: 'devis/nouveau', element: <RequirePermission permission="devis.demander"><NouveauDevis /></RequirePermission> },
  { path: 'devis/:devisId', element: <RequirePermission permission="devis.lire.propres"><DetailDevis /></RequirePermission> },
  { path: 'favoris', element: <RequirePermission permission="favoris.gerer"><MesFavoris /></RequirePermission> },
  { path: 'modeles', element: <RequirePermission permission="favoris.gerer"><MesModeles /></RequirePermission> },
];

export const navProFidelite: EntreeNav[] = [
  { libelle: 'Favoris', vers: '/pro/favoris', permission: 'favoris.gerer', icone: Heart },
  { libelle: 'Commandes récurrentes', vers: '/pro/modeles', permission: 'favoris.gerer', icone: Repeat },
  { libelle: 'Devis', vers: '/pro/devis', permission: 'devis.lire.propres', icone: FileSignature },
];
